import { useSyncExternalStore } from 'react'
import { pubSubSecureState } from '../../state/pubSub'
import { SecureState, SECURESTATE } from '../../state/state.secure'

const getSecureState =
    <T extends keyof SecureState>(key: T) =>
    () =>
        SECURESTATE[key]

// const getSecureSelectorState =
//     <T extends keyof SecureState>(key: T, valueKey: keyof SecureState[T]) =>
//     () =>
//         SECURESTATE[key][valueKey]

const subSecureState =
    <T extends keyof SecureState>(key: T) =>
    (callback: () => void) =>
        pubSubSecureState.on(key, callback)

export const useSecureState = <T extends keyof SecureState>(key: T) => {
    const state = useSyncExternalStore<SecureState[T]>(
        subSecureState(key),
        getSecureState(key),
        getSecureState(key),
    )

    return state
}

// export const useSecureStateSelector = <
//     T extends keyof SecureState,
//     K extends keyof SecureState[T],
// >(
//     key: T,
//     valueKey: K,
// ): SecureState[T][K] =>
//     useSyncExternalStore(
//         subSecureState(key),
//         getSecureSelectorState(key, valueKey),
//         getSecureSelectorState(key, valueKey),
//     )
